<template>
  <b-modal id="agreement-modal" scrollable ref="modal" hide-footer>
    <template slot="modal-header">
      <div class="m-modal-header">
        <h2 class="top-title mb-0">
          供应商认证协议
        </h2>
        <img
          src="@/assets/images/icon_modal_close.png"
          alt
          class="close-button"
          @click.stop="hide"
        />
      </div>
    </template>
    <template slot="default">
      <div class="m-modal-content">
        <h2>合同双方</h2>
        <h3>甲方：佛山国中意创房地产信息咨询有限公司</h3>
        <h3>乙方</h3>
        <span>(“双方”指甲方和乙方)</span>

        <p>
          鉴于：乙方基于中意网知名度和美誉度，愿意通过中意网平台为第三方需求方提供服务，就上述合作事宜，双方签订本合同。
        </p>
        <h2>第一条 定义</h2>
        <p>
          1.1中意网：甲方提供平台支持和运营服务的电子商务平台网站，包括网址为www.idea888.com的网站及其它甲方指定网站。
        </p>
        <p>1.2线上：在中意网发布企业信息、介绍企业服务。</p>
        <p>1.3线下：在中意网获取需求方信息并在线下提供实际服务内容。</p>
        <p>
          1.4资质文件：根据法律、法规和规章的规定或商品品牌持有者要求，乙方销售商品所必须具备的公司营业执照、税务登记证等相关证照以及有权经营、销售商品的资质及授权文件。
        </p>
        <p>
          1.7中意网规则：指标示在中意网之上的，与乙方经营有关的任何规范性文件，包括但不限于乙方后台信息公告、乙方后台帮助中心等。
        </p>
        <h2>第二条 服务内容及乙方店铺经营方式</h2>
        <p>
          2.1
          甲方依照本合同第九条约定为乙方开通店铺服务后，乙方可使用中意网发布商品信息，与愿意购买乙方商品的甲方其他用户进行在线交流，订立买卖合同，并向通过中意网购买其商品的用户提供售后服务，同时可参与中意网相关活动及使用中意网同意提供的其他有偿服务。
        </p>
        <p>
          2.2
          乙方店铺经营方式：乙方店铺内商品，均以乙方自身名义进行商品信息上传、展示、咨询答复、商品销售、
          物流配送服务及售后服务提供等;乙方销售及服务出现争议、纠纷、国家机关机构调查时，由乙方以销售者身份处理。中意网不参与乙方店铺的经营，不承担前述争议、纠纷、调查的法律后果，由乙方独立承担，如因此造成中意网损失的，乙方应予以赔偿。
        </p>
        <p>
          2.3甲方为促成乙方与采购商交易提供平台及相关服务。乙方、采购商应根据其审慎、合理的判断决定是否进行交易。甲方对于乙方、采购商买卖合同关系的订立、履行及风险不做出任何明示、默示的承诺或保证，亦不承担对交易未按期付款或造成任何损失等的垫付或赔偿等责任。
        </p>
        <h2>第三条 服务费和保证金条款</h2>
        <p>
          3.1
          乙方经营项目在达成每一单交易时应按比例向中意网缴纳服务费用，服务费收费标准参照中意网平台的《收费标准》。
        </p>
        <p>
          3.2
          乙方入驻甲方平台，乙方以“一店铺一保证金”原则向甲方缴纳保证金，用以保证店铺规范运营及对商品和服务质量进行担保。当乙方发生侵权、违约、违规行为时，甲方可以依照与乙方签署的本合同中相关约定及中意网规则扣除相应金额的保证金作为违约金或给予采购商的赔偿。
        </p>
        <p>
          3.3
          乙方与甲方合同终止时或乙方退出甲方平台时，如无违反本合同或中意网平台规则的情形，甲方自乙方退出之日起15个工作日内将保证金全额退还乙方，如有违规情形，按照甲方相关规定，扣除乙方相应保证金。
        </p>
        <h2>第四条合同与订单的效力</h2>
        <p>
          4.1本合同内容包括合同正文及所有中意网已经发布的或将来可能发布的各类规则。所有规则为合同不可分割的一部分，与合同正文具有同等法律效力。
        </p>
        <p>
          4.2乙方在使用中意网提供的各项服务的同时，承诺接受并遵守各项相关规则的规定。中意网有权根据需要不时地制定、修改本合同或各类规则，如本合同有任何变更，中意网将在网站上以公示形式通知予乙方。如乙方不同意相关变更，必须立即以书面通知的方式终止本合同。任何修订和新规则一经公布即自动生效，成为本合同的一部分。登录或继续使用服务将表示乙方接受经修订的合同。除另行明确声明外，任何使服务范围扩大或功能增强的新内容均受本合同约束。
        </p>
        <p>
          4.3乙方签署或在线接受本合同并不导致本合同立即生效，经过中意网审核通过并向乙方发出服务开通通知时，本合同即在乙方和中意网之间产生法律效力。
        </p>
        <h2>第五条 甲方权利义务</h2>
        <p>5.1为乙方销售产品提供平台和相关服务。</p>
        <p>
          5.2甲方应按采购商要求从监管的采购商的账户向乙方履行付款义务，具体付款时间、付款方式由具体订单确定。
        </p>
        <p>
          5.3甲方有权根据乙方资质文件和商品情况，对乙方注册数据、发布的信息和交易行为进行审核，决定商品是否可以在中意网上线。
        </p>
        <p>5.4甲方有权在中意网发布平台规则，乙方应遵守。</p>
        <p>
          5.5鉴于互联网服务具有的跨地域、新权益等特殊性，乙方同意，在甲方、采购商或其他第三方有证据指控乙方发布的商品涉嫌侵权且乙方在1个工作日内无法提供合理解释时，甲方可以采取包括但不限于商品隐藏、、暂停结算、乙方下线等方式在内的措施促进公平交易，同时甲方有权暂时停止为乙方提供服务直至乙方与采购商协商一致终止有关指控，因此造成甲方损害，乙方应向甲方作出全数补偿。
        </p>
        <p>
          5.6甲方有权根据业务调整和内部管理需要将本合同的权利全部或部分转让给甲方任何一家分公司或子公司、母公司，或甲方授权其甲方任何一家分公司或子公司、母公司履约本合同项下的义务，对其履约承担连带担保责任；乙方同意及确认在上述情况下无须通知和/或取得乙方确认。
        </p>
        <p>
          5.7甲方负责为乙方提供信息存放空间，并确保在非不可抗力情形下乙方信息数据安全。
        </p>
        <h2>第六条 乙方权利义务</h2>
        <p>
          6.1乙方是商品的所有权方、提供方和销售主体，对使用乙方商品时产生的人身或财产损害依法承担全部责任；
        </p>
        <p>6.2遵守甲方平台的各项规则，为甲方的服务提供必要的支持与帮助。</p>
        <p>6.3不得与甲方介绍的采购商私下达成合同及进行交易。</p>
        <p>6.4按照合同约定按时向甲方支付保证金、服务费。</p>
        <h2>第七条 乙方声明及保证</h2>
        <p>
          7.1
          保证在中意网提交的注册资料真实、准确、合法、有效，对获得的与自设密码共同使用的中意网用户名(店铺用户名)妥善保管，不得擅自转让或授权他人使用，并对利用该用户名和密码所进行的一切活动负所有责任。
        </p>
        <p>
          7.2保证符合本合同约定的入驻条件，保证向甲方提交的证明文件及其他相关证明真实、准确、合法、有效，并保证在上述资料发生变更时及时通知甲方，并在中意网上予以更新。
        </p>
        <p>
          7.3保证遵守本合同及附件的相关约定和中意网相关规则及流程，在使用中意网相关服务时严格按照上述约定及规则和流程使用，不从事任何有损甲方利益的行为。
        </p>
        <p>
          7.4保证对在中意网经营的商品拥有合法销售权，商品质量合格，符合国家相关质量标准，不侵犯任何第三方的合法权利，并对其商品质量及商品合法性独立承担所有法律责任。
        </p>
        <p>
          7.5保证在中意网发布的商品信息真实、准确，符合中意网规则及国家相关法律法规的规定，与实际出售的商品一致，不含任何夸大或虚假内容，并对商品信息承担独立的完全的法律责任。若发布的上述信息变更的，乙方应及时在中意网予以更新。若因信息未及时变更引起法律后果的，乙方独立承担所有责任。
        </p>
        <p>
          7.6
          保证在使用中意网进行交易的过程中遵守诚实信用原则，不在交易中采取欺诈及虚假宣传、混淆等不正当竞争行为，不扰乱网上交易的正常秩序，不从事与网上交易无关的行为。
        </p>
        <p>
          7.7保证不将从中意网获取的任何数据用于本合同约定以外的用途，同时保证未经甲方提前书面许可不得擅自获取、使用、传播中意网的任何资料，包括但不限于交易数据、用户信息、支付信息、甲方其他用户展示于中意网的信息等。
        </p>
        <p>
          7.8
          乙方不得在中意网发布任何吸引甲方采购商到其他平台或乙方自身网络销售平台或渠道进行交易的信息，也不得在配送包裹中夹带此类吸引甲方用户的信息。
        </p>
        <p>
          7.9
          未经甲方另行书面许可，乙方不得将本合同项下权利义务所有或部分转移给第三方;乙方聘请第三方代运营公司代表乙方运营店铺的，第三方代运营公司的一切行为均视同为乙方亲自实施，由乙方承担所有法律后果;乙方与第三方代运营公司间的权利义务关系由乙方与第三方代运营公司单独解决，不得影响到甲方及甲方其他用户的权利。
        </p>
        <p>
          7.10商品质量应与商品对外标识、说明、介绍等保持真实一致，不得出现伪造、掺假、假冒等现象，不得作虚假和夸大宣传；
        </p>
        <p>
          7.11商品不会出现已拆封的商品或“空盒”商品（缺少配件、说明书等随机附件，甚至没有主件）；
        </p>
        <p>
          7.12商品质量应符合相关法律法规的标准（如有）以及行业标准（如有），不危害人体健康、人身财产安全，符合保质期要求（如有），不违反包括但不限于所有与健康、安全、环境、标识、标签、原产国以及有毒物质有关的法律、法规；
        </p>
        <p>
          7.13商品如为境外进口，除应符合出口国及中国安全、质量标准外，还须提供海关完税凭证及所需的通关手续、出入境检验检疫机构检验合格证明（如适用）等。
        </p>
        <p>
          7.14乙方保证对所提供的食品、软硬件产品及附属设施、技术数据具有合法产权（包括但不限于所有权、知识产权等权利）或已取得合法授权，不存在侵犯他人合法权利的情形；如有，因此引起的法律责任和经济赔偿由乙方承担。如因此造成甲方被采购商要求承担责任的，乙方应赔偿甲方因此造成的全部损失，包括但不限于：直接损失、间接损失以及甲方被采购商追索、甲方向乙方追索所支出或承担的诉讼费用、律师费用和其他合理费用。
        </p>
        <p>
          7.15对交付采购商的产品，在约定的验收期间发现有瑕疵的，乙方应承担相应责任。验收后合理时间内发现有验收时虽尽合理注意义务仍不能发现之隐蔽瑕疵的，乙方仍应承担瑕疵担保责任。
        </p>
        <p>
          7.16乙方保证，凡有保质期的产品，乙方送达产品到采购商或采购商指定地点时，距该产品保质期到期日的时限不得少于该保质期总期限的三分之二（进口食品距该产品保质期到期日的时限不得少于该保质期总期限的二分之一）；但6个月以下保质期的产品，距该产品保质期到期日的时限不得少于该保质期总期限的四分之三。在保质期满后，采购商在保证期间发现的产品缺陷，乙方应承担相应责任。
        </p>
        <p>
          7.17乙方保证按照相关法律法规规定、合同规定及原厂规定承担售后服务，如法律法规、合同规定及原厂规定有不一致之处，乙方应按照对采购商最有利的方式执行。
        </p>
        <p>
          7.18
          商品一旦因质量问题而发生维修、退换时，因此而产生的维修或退换货费、往返运费均由乙方承担。
        </p>
        <h2>第八条　入驻条件及证明文件提交</h2>
        <p>8.1 入驻条件</p>
        <p>
          乙方申请成为中意网入驻乙方，在中意网开展经营活动，须满足以下条件：
        </p>
        <p>
          8.1.1
          乙方已依照中华人民共和国法律注册并领取合法有效的营业执照及其他经营许可;
        </p>
        <p>8.1.2乙方申请经营的商品来源合法，资质齐全;</p>
        <p>8.1.3乙方同意本合同及中意网相关规则。</p>
        <p>8.2 证明文件提交</p>
        <p>
          8.2.1
          乙方须根据中意网相关规则及要求向甲方提交证明文件或其他相关证明，包括但不限于营业执照、税务登记证、授权委托书、商标注册证、质检报告、报关单、检验检疫证书、产品来源地证明等。
        </p>
        <p>
          8.2.2
          乙方保证向甲方提供的上述证明文件或其他相关证明真实、合法、准确、有效，并保证上述证明文件或其他相关证明发生任何变更或更新时，及时通知甲方，若上述文件变更或更新导致乙方不符合本合同所规定入驻条件的，甲方有权单方所有或部分限制乙方经营，直至终止本合同。
        </p>
        <p>
          8.2.3
          乙方对其提交的证明文件或其他相应证明的真实性、合法性、准确性、有效性承担所有法律责任，若因乙方提交虚假、过期文件或未及时更新或通知证明文件导致纠纷或被相关国家机关处罚的，由乙方独立承担所有法律责任，如因此造成中意网损失的，乙方应予以赔偿。
        </p>
        <h2>第九条　店铺服务开通及停止</h2>
        <p>
          9.1
          对于乙方拟开展经营的特定店铺，甲方在乙方提出开店申请并满足以下条件后3个工作日内为乙方开通服务。
        </p>
        <p>9.1.1 乙方已按照中意网确定的规则足额缴纳保证金;</p>
        <p>
          9.1.2乙方已按照本合同及中意网相关规则提交证明文件或其他相关证明并已通过甲方审核;
        </p>
        <p>9.1.3乙方已注册成为中意网用户且本合同已签署生效;</p>
        <p>
          9.2
          甲方为乙方开通服务后，乙方可利用中意网用户名及自设密码登陆商家后台，根据中意网相关规则及流程向乙方特定店铺上传、发布商品信息，与用户交流达成交易，使用本合同约定的其他有偿服务等。
        </p>
        <p>9.3 乙方店铺服务的停止：</p>
        <p>
          9.3.1
          乙方需要停止店铺服务的，应至少提前七个工作日向甲方提出申请，经甲方审核同意后由甲方停止该店铺的服务功能;
        </p>
        <p>9.3.2 出现以下任一情形时，甲方有权随时停止乙方相关店铺的服务;</p>
        <p>1）乙方不满足入驻条件的;</p>
        <p>2）乙方提供虚假资质文件的;</p>
        <p>3）乙方产品价格、规格等信息标示出错，导致行政处罚、争议和纠纷的;</p>
        <p>
          4）乙方产品质量、标识不合格的，或者产品涉嫌走私、假冒伪劣、旧货、返修品的;
        </p>
        <p>5）乙方销售及服务出现侵犯第三方合法权利或违反法律法规规定的情形;</p>
        <p>
          6）其他违反本合同约定或中意网规则的，或者其他甲方认为侵犯中意网或消费者权益的。
        </p>
        <h2>第十条 违约责任</h2>
        <p>
          10.1
          乙方同意赔偿由于使用服务（包括但不限于将乙方资料展示在网站上）或违反本合同而给中意网造成的全部损失（包括但不限于由此产生的全额的诉讼费用和律师费）。乙方同意中意网不对任何乙方张贴的资料，包括诽谤性的、攻击性的或非法的资料承担任何责任；由于此类材料对其它用户造成的损失由乙方自行承担全部责任。
        </p>
        <p>
          10.2乙方承诺，不会采取任何手段或措施，包括但不限于明示或暗示用户或通过其他方式转移其可以通过中意网网络平台在线达成的交易，以规避向中意网支付相关服务费用。否则将视为严重违约，中意网将有权立即终止本合同，并将其保证金作为违约金予以划扣，还可就违约行为向乙方追偿。
        </p>
        <p>
          10.3除本合同及中意网规则另有约定之外，如一方发生违约行为，守约方可以书面通知方式要求违约方在指定的时限内停止违约行为，并就违约行为造成的损失进行索赔，如违约方未能按时停止违约行为，则守约方有权立即终止本合同。
        </p>
        <p>
          10.4乙方逾期支付甲方服务的，应根据应付款总额的每日支付千分之五向乙方支付违约金，按天累计，逾期超过15天的，甲方有权要求乙方按相当于居间报酬的30%承担违约金并赔偿损失。
        </p>
        <p>
          10.5乙方违反保密条款约定，乙方应按照所涉及的金额的30%或十万元／项／次中较高者向甲方支付违约金。
        </p>
        <p>
          10.6出现违反任何一款知识产权约定的情形，除按该条款约定承担相应的费用外，乙方还应向甲方支付所涉金额30%的违约金。
        </p>
        <p>
          10.7乙方违反保证或出现其他商业欺诈时，乙方应按照欺诈涉及金额的30%或者十万元／项／次中较高者向甲方支付违约金。本条款约定不影响乙方按照其他条款约定应承担的违约责任。本条中的“商业欺诈”是指乙方违反诚实信用原则，向甲方或采购商提供虚假资料、信息，或者隐瞒事实真相，从而欺骗甲方或采购商，获取不正当利益的商业行为。
        </p>
        <h2>第十一条 有限责任及免责</h2>
        <p>
          11.1
          不论在何种情况下，甲方均不对由于电力、网络、电脑、通讯或其他系统的故障、罢工(含内部罢工或劳工骚乱)、劳动争议、暴乱、起义、骚乱、生产力或生产资料不足、火灾、洪水、风暴、爆炸、战争、政府行为等不可抗力，国际、国内法院的命令或第三方的不作为而造成的不能服务或延迟服务承担责任。
        </p>
        <h2>第十二条 反商业贿赂条款</h2>
        <p>
          12.1双方均反对任何形式的商业贿赂行为。乙方承诺乙方或乙方董事、股东、员工、本合同的经办人、收款人、签约人、联系人与甲方员工及经办人没有直系、旁系亲属在内的任何意义上的关联关系，同时不得给予甲方相关人员以任何形式的利益（包括但不限于回扣、有价证券、贵重礼品、旅游、特殊招待、未经备案的关联交易或其他利益），否则视为乙方严重违约，甲方有权终止本合同且并追究乙方违约责任。
        </p>
        <p>
          12.2乙方通过乙方账户、乙方员工账户、本合同经办人账户向甲方经办人或甲方员工及其亲属或具有利害关系、关联关系的私人账户或公司账户汇款，且未在合同签署前以加盖乙方公司印章的书面形式披露的，视为商业贿赂行为。
        </p>
        <p>
          12.3除以书面形式披露经甲方盖章确认并作为本合同附件附于本合同之外，乙方保证甲方负责与乙方进行工作联系的职员或其之前任职的公司在签署本合同之前与乙方没有开展过任何形式的合作；在本合同有效期内，如有任何甲方或甲方关联企业在职员工成为乙方或乙方关联企业的股东或者管理人员，乙方必须立即书面通知甲方廉政部门。
        </p>
        <p>
          12.4上述约定一经违反即视为乙方严重违约，甲方有权扣留应付乙方的所有款项或向乙方追索人民币50万元作为违约金。违约金为双方协商一致同意为合理预计损害赔偿。
        </p>
        <p>
          12.5若甲方任何职员要求给予其任何形式的不当利益，乙方应立即通知甲方，甲方查实后必公正处理，并为此保密；同时，甲方将根据具体情况，以甲方的酌情权给予乙方更多的优惠的商业机会。
        </p>
        <p>12.6甲方廉政部门的电子邮件为：【lz@ccjmu.com 】</p>
        <h2>第十三条 保密与禁止不正当交易</h2>
        <p>
          13.1双方工作人员因执行本合同而知悉或持有双方任一方的任何商业秘密，以及双方因本合同所建立之关系，在合同履行过程中及履行完毕后，双方均应负保密义务。如有一方违反此义务给其中一方造成损失的，应负赔偿责任。
        </p>
        <p>
          13.2双方保证在本合同签订及履行过程中不存在一方人员向他方人员的贿赂行为以及其它不正当交易行为。否则其中一方有权在查实后随时终止合同，由此造成的一切损失由行贿或有不正当交易行为方负责。
        </p>
        <h2>第十四条 不可抗力</h2>
        <p>
          14.1甲、乙双方由于不可抗力造成不能履行合同的，可按其影响，部分或全部免除责任。但一方迟延履行后发生不可抗力的，不能免除责任。
        </p>
        <p>
          14.2当不可抗力事故终止或事故消除后，受事故影响的一方应尽快以电子邮件或传真通知他方。若因不可抗力事件持续30天或导致合同目的不能实现的，当事人可解除合同。
        </p>
        <h2>第十五条 合同的变更、终止、解除</h2>
        <p>
          15.1甲方有权随时解除本合同，只须提前30日以书面形式通知乙方，通知送达乙方地址时本合同解除。
        </p>
        <p>
          15.2乙方出现以下情形时，甲方有权无需预先告知即以书面通知的方式解除本合同，合同自通知送达之日解除。
        </p>
        <p>1）出现本合同或附件约定的解除合同情形时；</p>
        <p>
          2）受到政府行政主管部门吊销营业执照或停业处分，其它丧失合法经营身份或资格的情况发生时；
        </p>
        <p>3）申请破产、进入清算程序；</p>
        <p>4）未经过对方同意，把本合同的权利或义务全部或部分转给采购商的；</p>
        <p>5）有证据证明对方存在商业贿赂问题的。</p>
        <p>
          6）除本合同另有明确约定的情形外，甲方在下列情况下享有解除合同的权利：
        </p>
        <p>
          7）乙方经营状况严重恶化，或转移资产抽逃资金，或丧失商业信誉，或有丧失或可能丧失履行债务的其他情形的；
        </p>
        <p>8）乙方严重违反合同约定，经甲方书面催告7日后仍不改正的。</p>
        <p>
          15.3双方因任何原因停止合作后，并不免除乙方依据本合同应向采购商承担的售后服务及产品保证责任，乙方仍应按照本合同关于售后服务的相关约定履行售后服务义务及产品质量保证责任;如在甲乙双方合作终止后，因乙方商品质量问题或售后服务问题而导致甲方或其他第三方人身或财产损失的，乙方仍应独立承担所有责任。
        </p>
        <h2>第十六条 争议解决</h2>
        <p>
          16.1本合同受中国法律管辖，并须按中国法律解释。本合同双方于此同意就任何由于本合同双方因履行本合同产生的任何争议，均应接受甲方所在地法院的司法管辖。
        </p>
        <p>
          16.2如本合同的任何条款被视作无效或无法执行，则上述条款可被分离，其余部份则仍具有法律效力。
        </p>
        <h2>第十七条 其它</h2>
        <p>
          17.1本合同有效期自乙方签订本合同之日起为期两年。本合同签订之前，甲、乙双方如事实上已经进行了合作，本合同的有效期从事实上合作开始之日起计算，但合同期限仍以乙方签订本合同之日起为期两年。
        </p>
        <p>
          17.2合同期满前一个月双方开始协商签订新的合同。如本合同已到期，但新的合同尚未签订，乙方如仍在继续使用甲方平台及相关服务，为确保双方合作的延续性，本合同有效期自然顺延至新合同签订之日，最长不得超过60
          天。新合同一经签订，其生效日期将追溯至本合同到期日的次日，并取代原合同之各项约定，新合同签订后，本合同将自动终止。
        </p>
      </div>
    </template>
    <template slot="modal-footer" class="w-100">
      <p class="float-left">Modal Footer Content</p>
      <b-button variant="primary" size="sm" class="float-right">Close</b-button>
    </template>
  </b-modal>
</template>
<style lang="scss" scoped>
#agreement-modal {
  width: 60%;
  .m-modal-header {
    width: 100%;
    display: flex;
    align-items: center;
    .top-title {
      flex: 1;
      font-size: 1.88rem;
      color: $acentColor;
      text-align: center;
    }
    .close-button {
      color: $acentColor;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .m-modal-content {
    h2 {
      font-size: 1.75rem;
      color: #333333;
      margin-top: 2.3rem;
      margin-bottom: 1.8rem;
    }
    h3 {
      font-size: 1.5rem;
      color: #333333;
    }
    span {
      font-size: 1.25rem;
      color: #999999;
    }
    p {
      font-size: 1.13rem;
      color: #333333;
      text-indent: 2em;
      line-height: 2.38rem;
    }
  }
}
</style>

<script>
export default {
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    }
  }
};
</script>
